import _ from 'lodash';
import { CHANGE_CUSTOM_DIMMER } from '../../constants/ActionTypes';

const initialState = {
  visible: false,
};

/**
 * Custom Dimmer Reducer
 * @param {*} state
 * @param {*} action
 */
export default function customDimmer(state = initialState, action = {}) {
  switch (action.type) {
    case CHANGE_CUSTOM_DIMMER:
      return {
        ...state,
        visible: action.visible === undefined ? !state.visible : action.visible,
      };
    default:
      return state;
  }
}
